module.exports = __webpack_public_path__ + "static/media/c24.6625e6b6.png";